import { addToGeozoneRedux, deleteInGeozoneRedux, editInGeozoneRedux, filterGeozones, uploadToGeozoneRedux, } from '../utils/action_data';
export function geozoneReducer(PRELOAD) {
    return (state = PRELOAD.geozones ?? [], action) => {
        switch (action.type) {
            case 'CREATE_GEOZONE':
                return addToGeozoneRedux(state, action.geozone, action.geozone_id, action.user_id);
            case 'CREATE_GEOZONE_FROM_SERVER':
                return addToGeozoneRedux(state, action.added_geozone.geojson, action.added_geozone._id, action.added_geozone.user_id);
            case 'DELETE_GEOZONES':
                //Функция, которая удалит геозоны
                return deleteInGeozoneRedux(state, action.geozones);
            case 'DELETE_GEOZONES_FROM_SERVER':
                return filterGeozones(state, [action.geozone_id]);
            case 'UPDATE_GEOZONES_FROM_OLD_PROGRAM':
                return editInGeozoneRedux(state, action.all_geozones, true);
            case 'UPDATE_GEOZONES_FROM_SERVER':
                return editInGeozoneRedux(state, action.updated_geozones);
            case 'EDIT_GEOZONES':
                //Функция, которая изменит геозоны
                return editInGeozoneRedux(state, action.geozones);
            case 'UPLOAD_GEOZONES_FROM_FILE':
                return uploadToGeozoneRedux(state, action.user_id, action.geozones_arr);
            default:
                return state;
        }
    };
}
const default_state = {
    error: null,
    is_loading: false,
};
export const upload_geozones_reducer = (state = default_state, action) => {
    switch (action.type) {
        case 'GEOZONES_ATTACHMENT_SET_MESSAGE':
            return { ...state, error: action.content };
        case 'IS_LOADING_UPLOAD_GEOZONES':
            return { ...state, is_loading: action.is_loading };
        default:
            return state;
    }
};
